export const WORK_TIME_HELP_TEXT =
  'Hier werden alle geleisteten Zeiten angezeigt. Die Sollzeit berechnet sich aufgrund der Beschäftigung und der abgezogenen Abwesenheiten, Feiertage und Ferien. Die positive und negative Gleitzeit wird mittels einer roten oder grünen Statusbar dargestellt.';
export const PENDING_TIMES_HELP_TEXT =
  'Hier werden alle Zeiten angezeigt, die der Vorgesetzte noch nicht validiert hat, also weder genehmigt noch abgelehnt sind.';
export const TIME_BALANCE_HELP_TEXT =
  'Hier werden alle Zeiten angezeigt, die noch nicht für die Validierung an den Vorgesetzten freigegeben wurden.';

// PBI #2245: Vermerk (sessionStorage) fuer den Einrichtungs-Assistenten, dass das Passwort
// soeben beim Aktivieren festgelegt wurde - dann entfaellt dort der Passwort-Abschnitt.
export const PASSWORT_BEI_AKTIVIERUNG_GESETZT_KEY =
  'ireport.passwort-bei-aktivierung-gesetzt';
